import React from "react";
import Footer from "../../components/Footer/Footer";
import LandingHeader from "../../components/LandingHeader/LandingHeader";
import karinaImg from "../../assets/images/Karina Bocker, MHA - Headshot.jpg";
import evaImg from "../../assets/images/Eva Snow, MD - Headshot.JPG";
import storyImg from "../../assets/images/eva_and_grandma.jpg";
import { useLanguage } from "../../contexts/LanguageContext";

const aboutUsTranslations = {
  en: {
    title: 'About Us',
    ourStory: 'Our Story',
    karinaExperience: 'Karina\'s Experience',
    karinaBio: 'Karina is a healthcare strategist and early-stage founder with over a decade of experience in clinical operations, network development, and value-based care. She has worked across both provider and payer systems, helping healthcare organizations improve efficiency, patient engagement, and access. As the founder of UME Health, Karina leads the vision and development of Welby, an AI-powered health companion built to simplify care for underserved populations. Her work blends operational insight, health equity advocacy, and a passion for transforming patient experiences through technology.',
    evaBio: 'Dr. Snow is a retired internal medicine physician and co-founder of UME Health, with more than 30 years of experience delivering care to diverse and underserved communities. Her clinical background spans both outpatient and hospital-based settings, where she championed continuity of care and health literacy. At UME Health, she serves as a clinical advisor, helping to ensure Welby reflects the realities of everyday patients while remaining grounded in compassion, clarity, and practical utility.',
    storyP1: 'Welby was inspired by something deeply personal. After watching her grandmother navigate complex medical instructions, medications, and follow-ups, Karina saw firsthand how overwhelming healthcare can be, even for someone with strong family support. There were too many instructions, too many moving pieces, and not enough clarity.',
    storyP2: 'What should have felt manageable quickly became stressful.',
    storyP3: 'At the same time, Karina had spent over a decade working inside the healthcare system, partnering with providers, health plans, and care teams to improve outcomes and streamline operations. She understood how the system was designed to work… and where it often breaks down for patients.',
    storyP4: 'Welby was built at the intersection of those two experiences: real-life caregiving and real-world healthcare expertise.',
    storyP5: 'Because no one should have to figure it all out alone.'
  },
  es: {
    title: 'Nosotros',
    ourStory: 'Nuestra Historia',
    karinaExperience: 'La Experiencia de Karina',
    karinaBio: 'Karina es una estratega de la salud y fundadora en etapa inicial con más de una década de experiencia en operaciones clínicas, desarrollo de redes y atención basada en valor. Ha trabajado en sistemas tanto de proveedores como de pagadores, ayudando a las organizaciones de salud a mejorar la eficiencia, el compromiso de los pacientes y el acceso. Como fundadora de UME Health, Karina lidera la visión y el desarrollo de Welby, un compañero de salud con IA diseñado para simplificar la atención a poblaciones desatendidas. Su trabajo combina conocimientos operativos, defensa de la equidad en salud y una pasión por transformar las experiencias de los pacientes a través de la tecnología.',
    evaBio: 'La Dra. Snow es una médica internista jubilada y cofundadora de UME Health, con más de 30 años de experiencia brindando atención a comunidades diversas y desatendidas. Su experiencia clínica abarca entornos tanto ambulatorios como hospitalarios, donde defendió la continuidad de la atención y la alfabetización en salud. En UME Health, sirve como asesora clínica, ayudando a garantizar que Welby refleje las realidades de los pacientes cotidianos mientras permanece arraigado en la compasión, la claridad y la utilidad práctica.',
    storyP1: 'Welby se inspiró en algo profundamente personal. Después de ver a su abuela navegar por instrucciones médicas complejas, medicamentos y seguimientos, Karina vio de primera mano lo abrumadora que puede ser la atención médica, incluso para alguien con un fuerte apoyo familiar. Había demasiadas instrucciones, demasiadas piezas móviles y no suficiente claridad.',
    storyP2: 'Lo que debería haber sido manejable rápidamente se volvió estresante.',
    storyP3: 'Al mismo tiempo, Karina había pasado más de una década trabajando dentro del sistema de salud, colaborando con proveedores, planes de salud y equipos de atención para mejorar los resultados y agilizar las operaciones. Entendía cómo estaba diseñado el sistema para funcionar… y dónde a menudo se rompe para los pacientes.',
    storyP4: 'Welby se construyó en la intersección de esas dos experiencias: el cuidado real de la vida y la experiencia real del mundo de la salud.',
    storyP5: 'Porque nadie debería tener que resolver todo solo.'
  },
  tl: {
    title: 'Tungkol sa Amin',
    ourStory: 'Ang Aming Kuwento',
    karinaExperience: 'Ang Karanasan ni Karina',
    karinaBio: 'Si Karina ay isang strategist sa healthcare at early-stage founder na may higit sa isang dekada ng karanasan sa clinical operations, network development, at value-based care. Siya ay nagtatrabaho sa parehong provider at payer systems, tumutulong sa mga healthcare organizations na pagbutihin ang efficiency, patient engagement, at access. Bilang founder ng UME Health, si Karina ang namumuno sa vision at development ng Welby, isang AI-powered health companion na ginawa upang pasimplehin ang care para sa underserved populations. Ang kanyang trabaho ay naghahalo ng operational insight, health equity advocacy, at isang passion para sa pag-transform ng patient experiences sa pamamagitan ng technology.',
    evaBio: 'Si Dr. Snow ay isang retiradong internal medicine physician at co-founder ng UME Health, na may higit sa 30 taon ng karanasan sa pagbibigay ng care sa diverse at underserved communities. Ang kanyang clinical background ay sumasaklaw sa outpatient at hospital-based settings, kung saan siya ay nagtaguyod ng continuity of care at health literacy. Sa UME Health, siya ay nagsisilbi bilang clinical advisor, tumutulong upang tiyakin na ang Welby ay sumasalamin sa mga realidad ng araw-araw na mga pasyente habang nananatiling grounded sa compassion, clarity, at practical utility.',
    storyP1: 'Ang Welby ay inspirasyon mula sa isang bagay na lubhang personal. Matapos panoorin ang kanyang lola na nag-navigate sa mga komplikadong medical instructions, medications, at follow-ups, si Karina ay nakakita ng firsthand kung gaano kahirap ang healthcare, kahit na para sa isang tao na may malakas na family support. Mayroon masyadong maraming instructions, masyadong maraming moving pieces, at hindi sapat na clarity.',
    storyP2: 'Ang dapat ay manageable ay mabilis na naging stressful.',
    storyP3: 'Sa parehong oras, si Karina ay naglaan ng higit sa isang dekada sa pagtatrabaho sa loob ng healthcare system, nakikipagtulungan sa mga providers, health plans, at care teams upang pagbutihin ang outcomes at streamline ang operations. Siya ay naiintindihan kung paano idinisenyo ang system upang gumana… at kung saan ito madalas na nabibigo para sa mga pasyente.',
    storyP4: 'Ang Welby ay itinayo sa intersection ng dalawang karanasang iyon: real-life caregiving at real-world healthcare expertise.',
    storyP5: 'Dahil walang dapat mag-isa sa paglutas ng lahat.'
  }
};

const AboutUs = () => {
  const { language } = useLanguage();

  const t = (key) => {
    return aboutUsTranslations[language][key] || aboutUsTranslations.en[key];
  };
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <LandingHeader />

      <main className="flex-1 px-4 py-8 max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-12 text-gray-800">{t('title')}</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Karina Bocker */}
          <div className="bg-gray-50 p-6 rounded-lg shadow-md">
            <div className="flex flex-col items-center mb-4">
              <img 
                src={karinaImg} 
                alt="Karina Bocker, MHA" 
                className="w-32 h-32 rounded-full object-cover mb-4"
              />
              <h2 className="text-2xl font-semibold text-gray-800">Karina Bocker, MHA</h2>
            </div>
            <p className="text-gray-700 leading-relaxed">
              {t('karinaBio')}
            </p>
          </div>

          {/* Evangelina Snow */}
          <div className="bg-gray-50 p-6 rounded-lg shadow-md">
            <div className="flex flex-col items-center mb-4">
              <img 
                src={evaImg} 
                alt="Evangelina Snow, MD" 
                className="w-32 h-32 rounded-full object-cover mb-4"
              />
              <h2 className="text-2xl font-semibold text-gray-800">Evangelina Snow, MD</h2>
            </div>
            <p className="text-gray-700 leading-relaxed">
              {t('evaBio')}
            </p>
          </div>
        </div>

        {/* Our Story Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">{t('ourStory')}</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-semibold mb-6 text-gray-800">{t('karinaExperience')}</h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  {t('storyP1')}
                </p>
                <p>
                  {t('storyP2')}
                </p>
                <p>
                  {t('storyP3')}
                </p>
                <p>
                  {t('storyP4')}
                </p>
                <p className="italic">
                  {t('storyP5')}
                </p>
              </div>
            </div>
            
            <div className="flex justify-center">
              <img 
                src={storyImg} 
                alt="Woman and grandma looking at pill bottle" 
                className="rounded-lg shadow-md max-w-full h-auto"
                style={{maxWidth: '400px'}}
              />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutUs;
